/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useState, useEffect } from 'react';
import { ethers } from 'ethers'
import { useOutletContext, useParams, useNavigate } from "react-router-dom";
import AddLP from '../AddLP.js';
import InfoToken from '../InfoToken.js';
import SimpleMetadata from '../artifacts/contracts/SimpleMetadata.sol/SimpleMetadata.json'


function ManualFarm() {
    const navigate = useNavigate();
    const [manualAddress, setManualAddress] = useState(null);
    function handleChange(event) {
        const target = event.target;
        const value = target.value;
//        const name = target.name;
        setManualAddress(value);
    }

    function goManual() {
        navigate(manualAddress, { replace: true});
    }

    return (
        <>
            <div className="alert alert-warning" role="alert">
            No token address was give. Please enter one.
            </div>
            <div className="card">
                <div className=" m-1 p-3">
                    <form className="row g-3">
                        <div className="col-md-12">
                            <label htmlFor="manualAddress" className="form-label">Address</label>
                            <input type="text" className="form-control" id="manualAddress" name="manualAddress" value={manualAddress} onChange={handleChange} />
                        </div>
                        <div className="col-md-12">
                            <button type="button" className="btn btn-primary" onClick={goManual}>Go</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default function Farm() {
  const [web3,, accounts, myTokens,, selectedTokenIndex] = useOutletContext();
  const { tokenAddress } = useParams(); // specific token in the URL
  const [stakingContractFromMetadata, setStakingContractFromMetadata] = useState(null);
  const navigate = useNavigate();
  let navigateTo = null;

  async function loadStakingContract(tokenAddress) {
    const contract = new ethers.Contract(tokenAddress, SimpleMetadata.abi, web3);
    return await contract.metadata("staking");
  }

  var stakingContract;
  var targetToken;

  if (tokenAddress) {
    targetToken = tokenAddress;
    stakingContract = stakingContractFromMetadata;
    if (!stakingContractFromMetadata) {
        loadStakingContract(tokenAddress)
            .then(setStakingContractFromMetadata);
    }
  } else if (myTokens && selectedTokenIndex && myTokens[selectedTokenIndex - 1]) {
    targetToken = myTokens[selectedTokenIndex - 1].address;
    if (myTokens[selectedTokenIndex - 1].staking && myTokens[selectedTokenIndex - 1].staking[0]) {
        stakingContract = myTokens[selectedTokenIndex - 1].staking[0];
    }
    navigateTo = targetToken;
  } else {
    //targetToken remains null, will show manual component
  }

  useEffect(() => {
    if (navigateTo) {
        navigate(navigateTo, { replace: false});
    }
  });

  if (!targetToken) {
    return (<ManualFarm />)
  }

  return (
    <>
            <div className="alert alert-warning" role="alert">
            Anybody can create a token! Make sure the token address is correct before doing anything.
            </div>
      <h2>Farm</h2>

      <div className="lead">
        <div className="row g-3">
          <div className="col-md-6">
        {(web3 && targetToken && accounts) &&
                <InfoToken web3={web3} myToken={targetToken} />
        }
          </div>
          <div className="col-md-6">
        {(web3 && stakingContract && accounts) &&
                <AddLP web3={web3} stakingContract={stakingContract} myAddress={accounts[0]} />
        }
            </div>
      </div>
      </div>

    </>
  );
}